import React from 'react';
import DropdownFilterWidget from './widgets/DropdownFilterWidget';

export var PHARM_LOCATION_FILTER_DEFAULTS = {
  filterName: 'pharmLocationOid',
  sourceType: 'table',
  sourceName: 'PharmLocations',
  labelField: 'Name',
  valueField: 'Oid'
};

export function withPharmLocationDefaults(widget) {
  return {
    ...PHARM_LOCATION_FILTER_DEFAULTS,
    ...(widget || {})
  };
}

export default function PharmLocationFilterWidget(props) {
  return <DropdownFilterWidget {...props} widget={withPharmLocationDefaults(props.widget)} />;
}
